import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { ServerUrlService } from '../services/server-url.service'
import { environment } from 'src/environments/environment'
import { map, of, catchError } from 'rxjs'

export const jwtAuthGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService)
  const serverUrlService = inject(ServerUrlService)
  const router = inject(Router)

  // Helper function to redirect to login preserving query params
  const redirectToLogin = (): boolean => {
    const queryParams = route.queryParams
    router.navigate(['/login'], { queryParams, queryParamsHandling: 'merge' })
    return false
  }

  // Verifica se já existe token no localStorage (também usado pelos testes de
  // integração para injetar o usuário mockado via /auth/login/authenticated).
  const existingToken = localStorage.getItem('@otimus_clinic:jwt_token')

  if (environment.isIntegrationTest) {
    if (existingToken) {
      return auth.getAuthenticated(existingToken).pipe(
        map((resp) => {
          auth.user = resp.data.user
          auth.token = existingToken
          return true
        }),
        catchError(() => of(true))
      )
    }
    return of(true)
  }
  if (existingToken) {
    return auth.getAuthenticated(existingToken).pipe(
      map((resp) => {
        const tokenHost = resp.data.cmsHost
        const clientHost = serverUrlService.name

        // Allow localhost as special case (same logic as URL token validation)
        if (tokenHost !== clientHost && tokenHost !== 'localhost') {
          return redirectToLogin()
        }
        auth.user = resp.data.user
        auth.token = existingToken
        return true
      }),
      catchError(() => of(redirectToLogin()))
    )
  }

  // TODO: Remover validacao da rota, manter somente via postMessage
  const tokenFromRoute = route.queryParamMap.get('token')
  const regex = /[?&]token=([^&]+)/
  const tokenFromUrl = serverUrlService.url.match(regex)

  const token = tokenFromRoute || (tokenFromUrl ? tokenFromUrl[1] : null)

  if (!token) {
    return of(redirectToLogin())
  }

  return auth.getAuthenticated(token).pipe(
    map((resp) => {
      auth.token = token
      auth.user = resp.data.user

      const tokenHost = resp.data.cmsHost
      const clientHost = serverUrlService.getInfo('name')

      if (tokenHost !== clientHost && resp.data.cmsHost !== 'localhost') {
        return redirectToLogin()
      }

      return true
    }),
    catchError(() => {
      return of(redirectToLogin())
    })
  )
}
